import { allTechnicians } from "constants/technicians";
import {
  techniciansList,
  regionList,
  specializationList,
} from "constants/technicians";

const initialState = {
  techniciansList: {},
  regionList: {},
  specializationList: {},
  allTechnicians: {},
};

const technicians = (state = initialState, action) => {
  switch (action.type) {
    case techniciansList:
      return { ...state, techniciansList: action.payload };

    case regionList:
      return { ...state, regionList: action.payload };

    case specializationList:
      return { ...state, specializationList: action.payload };

    case allTechnicians:
      return { ...state, allTechnicians: action.payload };

    default:
      return state;
  }
};

export default technicians;